import { property, subclass } from "@arcgis/core//core/accessorSupport/decorators";
import Accessor from "@arcgis/core/core/Accessor";
import Collection from "@arcgis/core/core/Collection";

@subclass("SearchBoxViewModel")
export default class SearchBoxViewModel extends Accessor {

  @property()
  appMessages: any;

  @property({ readOnly: true })
  searchSuggestions: Object;

  @property({ readOnly: true })
  searchResults: Collection<[string, string]> = new Collection();

  @property({ readOnly: true })
  currentSearchValue: string = null;

  constructor(params?: any) {
    super(params);
  }

  handleSearch(e: CustomEvent): void {
    const value = (e?.target as HTMLCalciteInputElement)?.value?.trim();
    if (this.currentSearchValue === value) {
      return;
    }
    this._set("currentSearchValue", value);
    this._generateSearchResults(value);
  }

  setSearchSuggestions(suggestions: Object) {
    this._set("searchSuggestions", suggestions);
  }

  private _generateSearchResults(value: string): void {
    const results = this._getFilteredSearchResults(value);
    this.searchResults.removeAll();
    this.searchResults.addMany(results);
  }

  private _getFilteredSearchResults(value: string): [string, string][] {
    const lowercaseVal = value?.toLocaleLowerCase();
    const results: [string, string][] = Object.entries(this.searchSuggestions).filter(([t9nKey, searchTerm]: [string, string]) => {
      return searchTerm
        ?.toLocaleLowerCase()
        ?.trim()
        ?.indexOf(lowercaseVal) !== -1;
    }) as any;

    results.sort((
      [aT9N, aSearchTerm]: [string, string], 
      [bT9N, bSearchTerm]: [string, string]
    ) => {
      var aIndex = aSearchTerm?.toLocaleLowerCase()?.indexOf(lowercaseVal);
      var bIndex = bSearchTerm?.toLocaleLowerCase()?.indexOf(lowercaseVal);
      return aIndex - bIndex;
    });

    return results;
  }
}
